import React from "react";
import {
  MyMessagesMessageField,
  MyMessagesTitleField,
} from "./MyMessagesTextfields";
import Center from "../../../../widget/common/ui/Center";
import { ButtonSingle, ButtonDouble } from "../../../../widget/common/form/Button";
import AppTranslation from "../../../../service/app_translation/AppTranslation";

type MyMessagesFormType = {
  handleSubmit: () => void;
  handleCancel: () => void;
  handleSendMessage: () => void;
  fromChat: boolean;
};

const MyMessagesForm: React.FC<MyMessagesFormType> = ({
  handleSubmit,
  handleCancel,
  handleSendMessage,
  fromChat = false,
}) => {
  return (
    <form autoComplete="off" className="pt-4">
      <MyMessagesTitleField />
      <MyMessagesMessageField />

      <Center className="pt-4">
        {fromChat ? (
          <ButtonSingle width={350} handleClick={handleSendMessage}>
            {AppTranslation.text("send_once_off")}
          </ButtonSingle>
        ) : (
          <ButtonDouble
            title1="cancel"
            title2="submit"
            width={350}
            handleClick1={() => handleCancel()}
            handleClick2={() => handleSubmit()}
          />
        )}
      </Center>
    </form>
  );
};

export default MyMessagesForm;
